// @flow
import React, { Component } from "react";
import Question from "./Question";
import Intro from "./Intro";
import Outro from "./Outro";
import { mean } from "d3-array";

import type { Step, QuestionStep } from "../../data/quizData";

type QuizProps = {
  firstStep: Step,
  getStep: (id: string) => Step,
  questions: Array<QuestionStep>,
  showQRCode: boolean
};

type QuizState = {
  answers: { [id: string]: number },
  step: Step
};

export default class Quiz extends Component<void, QuizProps, QuizState> {
  state = {
    answers: {},
    step: this.props.firstStep
  };

  commit = (answer: { [id: string]: number }) => {
    this.setState(({ answers, step }: QuizState) => ({
      answers: { ...answers, ...answer },
      step: this.props.getStep(step.nextStep)
    }));
  };

  nextStep = () => {
    this.setState(({ step }: QuizState) => ({
      step: this.props.getStep(step.nextStep)
    }));
  };

  getScore = () => {
    const { questions } = this.props;
    const { answers } = this.state;

    const score = Math.ceil(
      100 - mean(questions, q => Math.abs(q.answerValue - answers[q.id]))
    );

    return score;
  };

  restart = () => {
    this.setState(() => ({ answers: {}, step: this.props.firstStep }));
  };

  render() {
    const { step } = this.state;

    return step.type === "intro"
      ? <Intro {...step} start={this.nextStep} />
      : step.type === "outro"
        ? <Outro
            {...step}
            restart={this.restart}
            score={this.getScore()}
            showQRCode={this.props.showQRCode}
          />
        : <Question
            key={step.id}
            step={step.step}
            totalSteps={this.props.questions.length}
            {...step}
            commit={value => this.commit({ [step.id]: value })}
          />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/Quiz.js